import ItemList from '../ItemList/ItemList'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router';
// import { getFirestore } from '../../services/getFirebase';
import { Typography, Box, CircularProgress, Button, Drawer, Alert, AlertTitle } from '@material-ui/core'
import BusquedaDrawer from '../Busqueda/BusquedaDrawer'
import BusquedaDrawerWhite from '../Busqueda/BusquedaDrawerWhite'
import axios from "axios";
import { useTheme } from '@material-ui/core/styles';
import Cookies from "universal-cookie";
import ProductFilters from '../ProductFilters/ProductFilters';
// import {config} from "../../config/config"
import {config} from "../../config/config"
import FilterListIcon from '@material-ui/icons/FilterList';

const cookies = new Cookies();

const ItemListContainer = () => {
	const theme = useTheme();
	const {patron} = useParams()
	// let patron = "wemb"

	const [products, setProducts] = useState([])
	const [filteredProducts, setFilteredProducts] = useState([])
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);
	const [initialLoad, setInitialLoad] = useState(true);
	const [totalResults, setTotalResults] = useState(0);
	const [requestVersion, setRequestVersion] = useState(0);
	const pageSize = 12;

	const [errorMessage, setErrorMessage] = useState(false);
	// Filter state
	const [filters, setFilters] = useState({ lista: [], label: [] });
	const [filterOpen, setFilterOpen] = useState(false);

	const observer = React.useRef();

	const lastElementRef = React.useCallback(node => {
		if (loading) return;
		if (observer.current) observer.current.disconnect();
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPage(prevPage => prevPage + 1);
			}
		});
		if (node) observer.current.observe(node);
	}, [loading, hasMore]);

	const token = cookies.get("token");
	const normalizedPattern = (patron || '').trim();
	const activeFilterCount = (filters.lista?.length || 0) + (filters.label?.length || 0);

	// Reset on search params change
	useEffect(() => {
		setPage(1);
		setProducts([]);
		setHasMore(true);
		setInitialLoad(true);
		setErrorMessage(false);
		setTotalResults(0);
		setFilters({ lista: [], label: [] });
	}, [patron]);

	useEffect(() => {
		let cancel = false;
		if (normalizedPattern.length < 3) {
			setProducts([]);
			setTotalResults(0);
			setHasMore(false);
			setLoading(false);
			setInitialLoad(false);
			return;
		}
		setLoading(true);

		const configuration = {
			method: "get",
			url: `${config.SERVER}/api/search/${encodeURIComponent(normalizedPattern)}?page=${page}&pageSize=${pageSize}`,
			headers: {
			  Authorization: `Bearer ${token}`,
			},
			withCredentials: true,
		      };
		      // make the API call
		      axios(configuration)
			.then((result) => {
				if (cancel) return;
				const newProducts = result.data.allProducts;
				const total = result.data.total;
				setTotalResults(total);
				setErrorMessage(false);
				
				setProducts(prev => {
					return page === 1 ? newProducts : [...prev, ...newProducts];
				});
				
				const totalPages = Math.ceil(total / pageSize);
				if (page >= totalPages) {
					setHasMore(false);
				}

				setLoading(false);
				setInitialLoad(false);
			})
			.catch((error) => {
				setErrorMessage(true)
				setLoading(false);
				setInitialLoad(false);
			  error = new Error();
			})
			return () => { 
				cancel = true;
			      }
	}, [normalizedPattern, page, requestVersion, token])
	
	// Filtering Effect
	useEffect(() => {
		let filtered = products;

		if (filters.lista && filters.lista.length > 0) {
			filtered = filtered.filter(product => filters.lista.includes(product.lista));
		}

		if (filters.label && filters.label.length > 0) {
			filtered = filtered.filter(product => filters.label.includes(product.label));
		}

		setFilteredProducts(filtered);
	}, [products, filters]);

	const toggleFilterDrawer = (open) => (event) => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
		  return;
		}
		setFilterOpen(open);
	};

	const retrySearch = () => {
		setPage(1);
		setProducts([]);
		setHasMore(true);
		setInitialLoad(true);
		setRequestVersion(version => version + 1);
	};

	return (
		<>
		{/* <Typography variant='h5'>Busqueda: "{patron}"</Typography> */}
		{(theme.palette.mode || theme.palette.type) === "dark" ? <BusquedaDrawer/> : <BusquedaDrawerWhite/>}
		{normalizedPattern.length >= 3 && (
			<Box sx={{ width: '100%', mt: 1 }}>
				<Typography variant="h6">Resultados para “{normalizedPattern}”</Typography>
				{!initialLoad && !errorMessage && (
					<Typography variant="body2" color="text.secondary">
						{totalResults === 1 ? '1 producto encontrado' : `${totalResults} productos encontrados`}
					</Typography>
				)}
			</Box>
		)}
		
		<Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px', marginRight: '16px', width: '100%' }}>
			<Button 
				variant="outlined" 
				startIcon={<FilterListIcon />} 
				onClick={toggleFilterDrawer(true)}
				size="small"
			>
				{activeFilterCount ? `Filtrar (${activeFilterCount})` : 'Filtrar'}
			</Button>
		</Box>

		<Drawer
			anchor="right"
			open={filterOpen}
			onClose={toggleFilterDrawer(false)}
		>
			<Box
				width={300} p={2}
				aria-labelledby="mobile-search-filters-title"
			>
				<Typography id="mobile-search-filters-title" variant="h6" sx={{ mb: 1 }}>Filtrar resultados</Typography>
				<ProductFilters 
					products={products} 
					filters={filters} 
					onChange={setFilters} 
				/>
				<Box display="flex" justifyContent="flex-end" mt={2}>
					<Button variant="contained" color="primary" onClick={toggleFilterDrawer(false)}>
						Ver Resultados
					</Button>
				</Box>
			</Box>
		</Drawer>

		{normalizedPattern.length < 3 ? (
			<Alert severity="info" sx={{ width: '100%', mt: 2 }}>
				Escribí al menos 3 caracteres para buscar por código o nombre.
			</Alert>
		) : errorMessage ? (
			<Alert
				severity="error"
				sx={{ width: '100%', mt: 2 }}
				action={<Button color="inherit" size="small" onClick={retrySearch}>Reintentar</Button>}
			>
				<AlertTitle>No pudimos completar la búsqueda</AlertTitle>
				Revisá la conexión e intentá nuevamente.
			</Alert>
		) : initialLoad && page === 1 ? (
			<Box sx={{ display: 'flex', mt:"30vh", height:"100%", justifyContent: 'center' }}>
				<CircularProgress aria-label="Buscando productos" />
			</Box>
		) : (
			<>
				<ItemList
					products={filteredProducts}
					emptyMessage={activeFilterCount
						? 'Probá quitar algún filtro para ampliar los resultados.'
						: `No encontramos coincidencias para “${normalizedPattern}”.`}
				/>
				
				{/* Sentinel for Infinite Scroll */}
				{!loading && hasMore && <div ref={lastElementRef} style={{ height: '20px', margin: '10px 0' }} />}
				
				{/* Bottom Loader */}
				{loading && page > 1 && (
					<Box display="flex" justifyContent="center" my={4}>
						<CircularProgress disableShrink/>
					</Box>
				)}
				
				{!hasMore && products.length > 0 && (
					<Box display="flex" justifyContent="center" my={2}>
						<Typography variant="body2" color="textSecondary">No hay más productos</Typography>
					</Box>
				)}
			</>
		)}	
		</>
	)
}

export default ItemListContainer
